import * as React from 'react';

import type { CongregationMembership } from '../../types/congregation';

export interface CongregationAccessContextValue {
  membership: CongregationMembership;
  isAdmin: boolean;
  refresh: () => Promise<void>;
}

const CongregationAccessContext = React.createContext<CongregationAccessContextValue | null>(
  null,
);

export const CongregationAccessProvider = CongregationAccessContext.Provider;

export function useCongregationAccess() {
  const ctx = React.useContext(CongregationAccessContext);
  if (!ctx) {
    throw new Error('useCongregationAccess must be used within a CongregationAccessProvider');
  }
  return ctx;
}
